export const PRODUCT_BACKLIST = 'Backlist';
export const PRODUCT_FRONTLIST = 'Frontlist';
export const PRODUCT_EXCERPT = 'Utdrag';
export const PRODUCT_ALL_JOURNALS = 'Alle tidsskrifter';
export const PRODUCT_LAW_COMMENTARY = 'Lovkommentarer';
export const PRODUCT_ALL_CONTRACTS = 'Alle kontrakter';
export const PACKAGE_EOS_GENERAL = 'Pakke: EØS-rett (generell)';
export const PACKAGE_METODE = 'Pakke: Metode';
export const PACKAGE_PERSPECTIVE = 'Pakke: Perspektivfag';
